import React, { createContext, useContext, useState } from 'react';

const TRACKS = [
  { id: 1, title: 'None of this Shit will last', duration: '4:48', file: '/audio/01-none-of-this-shit-will-last.mp3' },
  { id: 2, title: 'Reason',                      duration: '5:02', file: '/audio/02-reason.mp3' },
  { id: 3, title: 'Voidy Inside',                duration: '4:36', file: '/audio/03-voidy-inside.mp3' },
  { id: 4, title: 'Pink Truck',                  duration: '3:55', file: '/audio/04-pink-truck.mp3' },
  { id: 5, title: 'Lost my Way',                 duration: '4:21', file: '/audio/05-lost-my-way.mp3' },
  { id: 6, title: 'Darker Days',                 duration: '5:14', file: '/audio/06-darker-days.mp3' },
  { id: 7, title: 'Voidy Inside (Remix)',         duration: '6:08', file: '/audio/07-voidy-inside-remix.mp3' },
];

const AudioContext = createContext({ tracks: TRACKS, current: 0, playing: false, setCurrent: () => {}, setPlaying: () => {} });
export const useAudio = () => useContext(AudioContext);
export function AudioProvider({ children }) {
  const [current, setCurrent] = useState(0);
  const [playing, setPlaying] = useState(false);
  const safeSetCurrent = (indexOrUpdater) => {
    setCurrent(prev => {
      const next = typeof indexOrUpdater === 'function'
        ? indexOrUpdater(prev)
        : indexOrUpdater;
      return Math.max(0, Math.min(TRACKS.length - 1, next));
    });
  };
  return (
    <AudioContext.Provider value={{ tracks: TRACKS, current, setCurrent: safeSetCurrent, playing, setPlaying }}>
      {children}
    </AudioContext.Provider>
  );
}
